import { UserCheck } from "lucide-react";
import React from "react";

import { Button } from "./button";

interface UITourBannerProps {
  text: string;
  className?: string;
  showBackButton?: boolean;
  onboardingStep?: number | null;
}

export const UITourBanner: React.FC<UITourBannerProps> = ({
  text,
  className = "w-full mb-4 p-4",
  showBackButton = true,
  onboardingStep = null
}) => {
  const handleBackToOnboarding = () => {
    const stepPath = onboardingStep ? `/onboarding/${onboardingStep}` : "/onboarding";
    window.location.href = stepPath;
  };

  return (
    <div className={`${className} bg-yellow-50/10 border border-yellow-200/20 rounded-lg`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <UserCheck className="w-5 h-5 text-yellow-400" />
          </div>
          <div className="flex-1 text-left">
            <p className="text-sm text-yellow-200/80">
              {text}
            </p>
          </div>
        </div>
        {showBackButton && (
          <Button
            onClick={handleBackToOnboarding}
            variant="outline"
            size="sm"
            className="ml-4 text-yellow-200 border-yellow-200/30 hover:bg-yellow-50/10 whitespace-nowrap"
          >
            Back to Onboarding
          </Button>
        )}
      </div>
    </div>
  );
};